import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { useMarkupContext } from "@context-providers/markup/markup-context";
import { ChevronLeftIcon, ChevronRightIcon, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useMarkupsViewQueryParams } from "@pages/project-details/project-markups/calendar/use-markups-view-query-params";
import { AnnotationSidePanelEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/** Steps to the previous or next listed annotation */
export function MarkupSidePanelNavigation(t0) {
  const $ = _c(35);
  const {
    markup,
    markups
  } = t0;
  const {
    updateSelectedMarkup,
    isMarkupUpdateInProgress
  } = useMarkupContext();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    viewMode
  } = useMarkupsViewQueryParams();
  let t1;
  if ($[0] !== markup) {
    t1 = t2 => {
      const {
        id
      } = t2;
      return id === markup.id;
    };
    $[0] = markup;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const index = markups.findIndex(t1);
  if (index < 0 || markups.length < 2) {
    return null;
  }
  let t2;
  if ($[2] !== isMarkupUpdateInProgress) {
    t2 = isMarkupUpdateInProgress();
    $[2] = isMarkupUpdateInProgress;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isUpdating = t2;
  let t3;
  if ($[4] !== index || $[5] !== markups || $[6] !== trackEvent || $[7] !== updateSelectedMarkup || $[8] !== viewMode) {
    t3 = function stepTo(direction) {
      updateSelectedMarkup(markups[direction === "previous" ? index - 1 : index + 1]);
      trackEvent({
        name: AnnotationSidePanelEvents.stepToAnnotation,
        props: {
          direction,
          viewMode
        }
      });
    };
    $[4] = index;
    $[5] = markups;
    $[6] = trackEvent;
    $[7] = updateSelectedMarkup;
    $[8] = viewMode;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const stepTo = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      alignItems: "center",
      gap: 0.5
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = isUpdating || index === 0;
  let t6;
  if ($[11] !== stepTo) {
    t6 = () => stepTo("previous");
    $[11] = stepTo;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      "aria-label": "Previous annotation"
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6) {
    t8 = <SphereIconButton component={ChevronLeftIcon} buttonSize="30px" isDisabled={t5} onClick={t6} iconButtonProps={t7} dataTestId="markup-side-panel-previous" />;
    $[14] = t5;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      color: "text.secondary"
    };
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = index + 1;
  let t11;
  if ($[18] !== t10) {
    t11 = <var>{t10}</var>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== markups.length) {
    t12 = <var>{markups.length}</var>;
    $[20] = markups.length;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <Text variant="bodyS" sx={t9}>{t11} of {t12}</Text>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = isUpdating || index === markups.length - 1;
  let t15;
  if ($[25] !== stepTo) {
    t15 = () => stepTo("next");
    $[25] = stepTo;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      "aria-label": "Next annotation"
    };
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t14 || $[29] !== t15) {
    t17 = <SphereIconButton component={ChevronRightIcon} buttonSize="30px" isDisabled={t14} onClick={t15} iconButtonProps={t16} dataTestId="markup-side-panel-next" />;
    $[28] = t14;
    $[29] = t15;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t13 || $[32] !== t17 || $[33] !== t8) {
    t18 = <Stack direction="row" sx={t4}>{t8}{t13}{t17}</Stack>;
    $[31] = t13;
    $[32] = t17;
    $[33] = t8;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  return t18;
}